import type { EndpointDef, PermissionGroupDef } from "@/features/users/data/endpoints";

/**
 * Resuelve los document ids de un grupo a paths HTTP (`EndpointDef.id`).
 * Ignora refs huérfanas (doc id sin permiso en el catálogo).
 */
export function pathsForGroup(
  group: PermissionGroupDef,
  permissionsByDocId: Map<string, EndpointDef>
): string[] {
  const paths: string[] = [];
  for (const docId of group.permissionIds) {
    const ep = permissionsByDocId.get(docId);
    if (ep?.id) paths.push(ep.id);
  }
  return paths;
}

/**
 * Toggle merge/remove de un conjunto de paths sobre la selección actual.
 * Si la mayoría ya está seleccionada, los quita; si no, los agrega.
 * No toca paths ajenos al conjunto.
 */
export function toggleIdsInSelection(current: string[], ids: string[]): string[] {
  if (ids.length === 0) return current;

  const selectedSet = new Set(current);
  const idsSet = new Set(ids);
  const selectedCount = ids.filter((id) => selectedSet.has(id)).length;
  const shouldDeselect = selectedCount * 2 >= ids.length;

  if (shouldDeselect) {
    return current.filter((id) => !idsSet.has(id));
  }

  const merged = new Set(current);
  for (const id of ids) merged.add(id);
  return Array.from(merged);
}

/**
 * True si todos los paths del grupo están en la selección.
 */
export function isGroupFullySelected(
  groupPaths: string[],
  selected: ReadonlySet<string>
): boolean {
  if (groupPaths.length === 0) return false;
  return groupPaths.every((path) => selected.has(path));
}
